import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown, faDollarSign, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { Container } from 'reactstrap';

import Price from 'Components/Utility/Price/Price';
import Drm from 'Components/Utility/Drm';

function BundleComicPoints({
  maxPrice,
  totalPageCount,
  downloadTypes,
  mixedBundle,
  productTypes,
  validDrm,
}) {
  return (
    <div className="BundlePoints BundlePoints--comic">
      <Container className="BundlePoints__points">
        <div className="BundlePoints__point">
          <div className="BundlePoints__dollarIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faDollarSign} />
          </div>
          <div className="BundlePoints__pointText">
            <FormattedMessage
              id="comic-bar.worth_of"
              defaultMessage="Get {price} worth of digital {type}"
              values={{
                price: <Price price={maxPrice} />,
                type: mixedBundle ? <FormattedMessage
                  id="comic-bar.worth_of_products"
                  defaultMessage="products"
                /> : <FormattedMessage
                  id="comic-bar.worth_of_comics"
                  defaultMessage="comics"
                />,
              }}
            />
          </div>
        </div>

        <div className="BundlePoints__point">
          <div className="BundlePoints__gameIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faBookOpen} />
          </div>
          <div className="BundlePoints__pointText">
            <FormattedMessage
              id="comic-bar.awesome_comics_plural"
              defaultMessage="{totalComics, plural, one {# Awesome comic} other {# Awesome comics}}"
              values={{ totalComics: productTypes.total.comic }}
            />
            {productTypes.total.book &&
              <FormattedMessage
                id="comic-bar.awesome_books_plural"
                defaultMessage=" + {totalBooks, plural, one {# eBook} other {# eBooks}}"
                values={{ totalBooks: productTypes.total.book }}
              />
            }
            {productTypes.total.software &&
              <FormattedMessage
                id="comic-bar.awesome_software_plural"
                defaultMessage=" + {totalSoftware} software"
                values={{ totalSoftware: productTypes.total.software }}
              />
            }
            {totalPageCount > 0 &&
              <React.Fragment>
                <span className="mx-1">-</span>
                <FormattedMessage
                  id="comic-bar.awesome_comics_pages"
                  defaultMessage="{totalPageCount} pages"
                  values={{ totalPageCount: `${Math.floor(totalPageCount / 100) * 100}+` }}
                />
              </React.Fragment>
            }
          </div>
        </div>

        {validDrm[0] !== 'idw' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faFileArrowDown} />
            </div>
            <div className="BundlePoints__pointText">

              {(isEmpty(downloadTypes) || downloadTypes.length > 1) &&
                <FormattedMessage id="comic-bar.multi-format-drm" defaultMessage="Multi-format DRM-Free downloads" />
              }
              {downloadTypes && downloadTypes.length === 1 &&
                <FormattedMessage
                  id="comic-bar.comic-delivery-pdf"
                  defaultMessage="DRM-Free {fileType} downloads"
                  values={{
                    fileType: <span className="text-uppercase">{downloadTypes[0]}</span>,
                  }}
                />
              }
            </div>
          </div>
        }

        {validDrm[0] === 'idw' &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__icon">
              <Drm drmType="idw" />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="comic-bar.redeem-on-drm"
                defaultMessage="Redeem on the {drm} app"
                values={{
                  drm: <span className="text-uppercase">
                    {validDrm[0]}
                  </span>,
                }}
              />
            </div>
          </div>
        }
      </Container>
    </div>
  );
}

BundleComicPoints.propTypes = {
  maxPrice: PropTypes.shape({}),
  totalPageCount: PropTypes.number,
  downloadTypes: PropTypes.arrayOf(PropTypes.string),
  mixedBundle: PropTypes.bool,
  productTypes: PropTypes.shape({}),
  validDrm: PropTypes.arrayOf(PropTypes.string),
};

BundleComicPoints.defaultProps = {
  maxPrice: {},
  totalPageCount: 0,
  downloadTypes: [],
  mixedBundle: false,
  productTypes: {},
  validDrm: [],
};

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(BundleComicPoints);
